import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function HomeAdditionsHero() {
  return <section id="homeadditionshero" data-nav="light" className="relative overflow-hidden bg-background text-foreground pt-12 pb-16 md:pt-20 md:pb-24 isolate">
      {/* 4D isometric glass atmospheric decoration */}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" aria-hidden="true">
        <div className="absolute -top-24 right-1/4 h-80 w-80 rounded-full bg-chart-1/10 blur-3xl" />
        <div className="absolute top-1/2 -left-20 h-72 w-72 rounded-full bg-chart-2/5 blur-3xl" />
        <div className="absolute right-10 bottom-4 h-48 w-48 rounded-2xl border border-border/50 bg-card/40 rotate-12 backdrop-blur-xs shadow-xs" />
        <div className="absolute right-24 bottom-12 h-32 w-32 rounded-xl border border-chart-1/20 bg-accent/30 -rotate-6 backdrop-blur-xs" />
      </div>

      <div className="container mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        {/* Layered Glass Hero Panel */}
        <div className="relative rounded-2xl border border-border/70 bg-card/60 p-6 sm:p-10 md:p-14 shadow-sm backdrop-blur-md">
          {/* Subtle copper accent indicator */}
          <div className="mb-6 flex items-center">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/" className="text-muted-foreground hover:text-foreground">
                      Home
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <span className="text-muted-foreground text-sm">Services</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-medium text-foreground">
                    Home Additions
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* Heading */}
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-foreground text-balance">
            Home Additions in Decatur, GA
          </h1>

          {/* Intro Paragraph */}
          <p className="mt-6 max-w-3xl text-base sm:text-lg md:text-xl leading-relaxed text-muted-foreground">
            Seamlessly expand your historic bungalow, craftsman, or mid-century residence. We design and construct thoughtful ground-floor expansions, second-story additions, and custom living suites that preserve Decatur&apos;s architectural charm while delivering modern square footage.
          </p>
        </div>
      </div>
    </section>;
}